import React from 'react';
import './TimelineComponent.css';
import { FaUserMd, FaCalendarCheck, FaFileMedicalAlt, FaHeartbeat } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const HorizontalTimelineComponent = () => {
  const { t } = useTranslation();

  const steps = [
    {
      stepKey: "register",
      icon: <FaHeartbeat />
    },
    {
      stepKey: "choose",
      icon: <FaUserMd />
    },
    {
      stepKey: "schedule",
      icon: <FaCalendarCheck />
    },
    {
      stepKey: "access",
      icon: <FaFileMedicalAlt />
    }
  ];

  return (
    <div className="timeline-container-ticket">
      <h2 className="timeline-title-ticket">{t("timeline.title")}</h2>
      <div className="timeline-wrapper-ticket">
        {steps.map((step, index) => (
          <div key={index} className="timeline-step-ticket">
            <div className="timeline-step-number-ticket">{t(`timeline.steps.${step.stepKey}.step`)}</div>
            <div className="timeline-icon-ticket">{step.icon}</div>
            <div className="timeline-description-ticket">{t(`timeline.steps.${step.stepKey}.description`)}</div>
            <div className="timeline-action-ticket">{t(`timeline.steps.${step.stepKey}.action`)}</div>
            {index !== steps.length - 1 && <div className="timeline-connector-ticket"></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalTimelineComponent;
